export enum IconWeight {
  SOLID = 'solid',
  REGULAR = 'regular',
  LIGHT = 'light',
  DUOTONE = 'duotone',
  BRANDS = 'brands',
}
